// extracted by mini-css-extract-plugin
export default {"container":"orders_container__8AAVq","orders__container":"orders_orders__container__hsFkK"};